import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import Reveal from "@/components/Reveal";

export default function Offers() {
  const [offers, setOffers] = useState([]);
  const [deals, setDeals] = useState([]);
  const [params] = useSearchParams();

  useEffect(() => {
    api.get("/offers").then((r) => setOffers(r.data));
    // Show products that have real discounts
    api.get("/products?limit=60").then((r) => setDeals(r.data.items.filter((p) => p.mrp && p.mrp > p.price)));
  }, []);

  return (
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 py-10">
      <h1 className="text-4xl font-extrabold text-midnight">Offers</h1>
      <p className="mt-1 text-muted-foreground">Real value across all four marts — MRP, selling price and actual discount shown transparently. No fake discounts.</p>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 gap-5">
        {offers.map((o, i) => (
          <Reveal key={o.slug} delay={i * 0.06}>
            <div data-testid={`offer-${o.slug}`} className="group relative h-44 overflow-hidden rounded-3xl">
              <img src={o.banner} alt={o.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-midnight/55" />
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <span className="text-[11px] font-bold uppercase tracking-wide text-gold">{o.type}</span>
                <h3 className="text-lg font-extrabold text-white">{o.title}</h3>
                <p className="text-xs text-white/70 line-clamp-2">{o.description}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <h2 className="mt-14 mb-6 text-2xl font-extrabold text-midnight">Deals You'll Love</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
        {deals.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </div>
  );
}
